export default [
  { value: "none", label: "Selecionar" },
  { value: "00", label: "00 - Tributada integralmente." },
  { value: "20", label: "20 - Com redução de base de cálculo." },
  { value: "40", label: "40 - Isenta." },
  { value: "41", label: "41 - Não tributada." },
  {
    value: "60",
    label: "60 - ICMS cobrado anteriormente por substituição tributária."
  },
  { value: "99", label: "99 - Outras operações." }
];



// WEBPACK FOOTER //
// ./src/core/enum/cst-values.enum.js